module.exports = __webpack_public_path__ + "img/kayak_1413_3.9fa354ca.jpg";